import { api } from 'services';

export async function showPerfil(id: number | string) {
    const { data } = await api.get(`/permissions/roles/${id}`);
    return data;
}
